<template>
    <v-list-subheader v-if="mainTitle" :title="mainTitle" class="text-h6" />
    <v-divider v-if="seperator"></v-divider>
    <v-list-item class="py-4">
        <template #prepend>
            <v-icon :color="iconColor" size="24" class="mr-4">{{ icon }}</v-icon>
        </template>
        <div>
            <v-list-item-title class="text-h6 mb-1">{{ title }}</v-list-item-title>
            <v-list-item-subtitle class="text-subtitle-1">{{ value }}</v-list-item-subtitle>
        </div>
        <template v-if="action" #append>
            <v-btn
                :color="getButtonColor(actionDisabled, actionColor)"
                :prepend-icon="actionIcon"
                size="large"
                variant="text"
                :disabled="actionDisabled"
                @click="actionAction"
            >
                {{ actionText }}
            </v-btn>
        </template>
    </v-list-item>
</template>

<script setup lang="ts">
import { ProfileItem } from '@/features/Profile/container/Profile.vue';

const getButtonColor = function (actionDisabled?: boolean, actionColor?: string) {
    return actionDisabled ? '' : actionColor;
};

withDefaults(defineProps<ProfileItem>(), {
    actionDisabled: false
});
</script>
